import { all, call } from "redux-saga/effects";
import onCreateGroup from "./createGroup";
import onDeleteGroup from "./deleteGroup";
import onEditGroup from "./editGroup";
import onGetAllGroup from "./getAllGroups";
import onGetExam from "./getSingleGroup";

export default function* examGroupSagas() {
  yield all([
    call(onCreateGroup),
    call(onGetAllGroup),
    call(onGetExam),
    call(onEditGroup),
    call(onDeleteGroup),
  ]);
}
